import checkStatus from '../utils/checkStatus';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import api from '../utils/api';
import dispatchHttpError from '../utils/dispatchHttpError';
import JwtStore from './JwtStore'

export default {
  fetch() {
    return fetch(api(`manuals`), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.MANUALS_FETCH_COMPLETE,
        collections: response,
      }))
      .catch(dispatchHttpError);
  }
}
